module.exports = __webpack_public_path__ + "static/img/turntable_go.1de95c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/turntable_go.png
// module id = OlcX
// module chunks = 59